import { ReactNode } from "react";

export class MenuSaurusModel {
  constructor(public label: string, public icon: ReactNode, public click: () => any) { }
}
